<template>
    <div>
        <app-erros-box
            :erros="['ENTREGA INDISPONÍVEL']"
            v-if="!entrega"
        ></app-erros-box>
        <app-contratacao-detalhar
            :contratacao="entrega.contratacao"
            :contratacoesServicos="contratacoesServicos"
            :movimentosServicos="movimentosServicos"
            @obterAtualizacao="obterEntregaAtualizada()"
            v-if="entrega"
        >
            <template slot="footer">
                <slot name="contratacaoFooter"></slot>
            </template>
        </app-contratacao-detalhar>
        <app-entrega-detalhar
            :entrega="entrega"
            :movimentosServicos="movimentosServicos"
            :entregasServicos="entregasServicos"
            :perfilGestor="perfilGestor"
            :perfilGerente="perfilGerente"
            :perfilUabs="perfilUabs"
            @obterAtualizacao="obterEntregaAtualizada()"
            v-if="entrega"
        >
            <template slot="botoes">
                <msg-erro-comprometimento :entrega="entrega">
                </msg-erro-comprometimento>
                <app-entrega-enviar-para-aprovacao
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                ></app-entrega-enviar-para-aprovacao>
                <entrega-associar-evento
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                    v-if="perfilGestor"
                ></entrega-associar-evento>
                <app-entrega-aprovar-reprovar
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                    v-if="perfilGestor || perfilGerente"
                ></app-entrega-aprovar-reprovar>
                <entrega-cancelar
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                    v-if="perfilGestor"
                ></entrega-cancelar>
                <entrega-atualizar-valor-hora
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                    v-if="perfilGestor || perfilUabs"
                ></entrega-atualizar-valor-hora>
                <entrega-atualizar-data-previsao
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                    v-if="perfilGestor || perfilUabs"
                >
                </entrega-atualizar-data-previsao>
                <entrega-solicitar-reabertura
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                    v-if="perfilGestor"
                >
                </entrega-solicitar-reabertura>
            </template>
            <template slot="footer">
                <app-entrega-enviar-para-aprovacao
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                ></app-entrega-enviar-para-aprovacao>
                <app-entrega-aprovar-reprovar
                    :entrega="entrega"
                    :entregasServicos="entregasServicos"
                    @obterEntregaAtualizada="obterEntregaAtualizada()"
                    v-if="perfilGestor"
                ></app-entrega-aprovar-reprovar>
                <slot name="entregaFooter"></slot>
            </template>
        </app-entrega-detalhar>
        <app-entrega-anexos
            :entrega="entrega"
            :entregasServicos="entregasServicos"
            @obterEntregaAtualizada="obterEntregaAtualizada()"
            v-if="entrega"
        >
            <template slot="botoes">
                <slot name="anexosBotoes"></slot>
            </template>
            <template slot="acoes" slot-scope="data">
                <slot name="anexosAcoes" v-bind="data"></slot>
            </template>
        </app-entrega-anexos>
        <app-entrega-raht
            :entrega="entrega"
            :entregasServicos="entregasServicos"
            @obterEntregaAtualizada="obterEntregaAtualizada()"
            v-if="entrega"
        ></app-entrega-raht>
    </div>
</template>

<script>
import ContratacaoDetalhar from './../contratacoes/ContratacaoDetalhar'
import EntregaDetalhar from './EntregaDetalhar'
import EntregaAnexos from './EntregaAnexos'
import EntregaRaht from './EntregaRaht'
import EntregaEnviarParaAprovacao from './EntregaEnviarParaAprovacao'
import EntregaAtualizarValorHora from './EntregaAtualizarValorHora'
import EntregaAprovarReprovar from './EntregaAprovarReprovar'
import EntregaAssociarEvento from './EntregaAssociarEvento'
import EntregaMsgErroComprometimento from './EntregaMsgErroComprometimento'
import EntregaCancelar from './EntregaCancelar'
import EntregaAtualizarDataPrevisao from './EntregaAtualizarDataPrevisao'
import { entregaStatus } from './EntregaStatus'
import EntregaSolicitarReabertura from './EntregaSolicitarReabertura'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            default: () => ({})
        },

        perfil: {
            type: String,
            default: () => ''
        }
    },

    data() {
        return {}
    },

    methods: {
        obterEntregaAtualizada() {
            this.$emit('obterEntregaAtualizada')
        }
    },

    computed: {
        perfilGestor() {
            return (
                this.$route.name == 'Gestores_Entregas_Detalhar' ||
                this.$route.name == 'Gestores_Entregas_Detalhar2'
            )
        },

        perfilUabs() {
            return this.$route.name == 'Uabs_Entregas_Detalhar'
        },

        perfilGerente() {
            return (
                (this.$route.name == 'Gerentes_Entregas_Detalhar' ||
                    this.$route.name == 'Gerentes_Entregas_Detalhar2') &&
                this.entrega.status == entregaStatus.EM_APROVACAO_GERENTE
            )
        }
    },

    components: {
        AppContratacaoDetalhar: ContratacaoDetalhar,
        AppEntregaDetalhar: EntregaDetalhar,
        AppEntregaAnexos: EntregaAnexos,
        AppEntregaRaht: EntregaRaht,
        AppEntregaEnviarParaAprovacao: EntregaEnviarParaAprovacao,
        AppEntregaAprovarReprovar: EntregaAprovarReprovar,
        EntregaAssociarEvento: EntregaAssociarEvento,
        MsgErroComprometimento: EntregaMsgErroComprometimento,
        EntregaCancelar: EntregaCancelar,
        EntregaAtualizarValorHora: EntregaAtualizarValorHora,
        EntregaAtualizarDataPrevisao,
        EntregaSolicitarReabertura
    }
}
</script>
